import { render, staticRenderFns } from "./NKWChangedBookingsTable.vue?vue&type=template&id=31ef6a9e&scoped=true&"
import script from "./NKWChangedBookingsTable.vue?vue&type=script&lang=js&"
export * from "./NKWChangedBookingsTable.vue?vue&type=script&lang=js&"
import style0 from "./NKWChangedBookingsTable.vue?vue&type=style&index=0&id=31ef6a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef6a9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDataTable,VIcon})
